module.exports = __webpack_public_path__ + "media/images/dashed_card-c4b4ad2aafe451c1ed418474f8c8398a.svg";